import WebConstant from "../WebConstant";

export function isValidUrl(destinationPageUrl) {
  // Check if the URL is valid
  let domainName = null;
  let isValidDurl = false;

  if (destinationPageUrl === null || destinationPageUrl === "") {
    return isValidDurl;
  }

  try {
    const url = new URL(destinationPageUrl);
    domainName = url.hostname;
  } catch (e) {
    console.debug(`Invalid url - ${destinationPageUrl}`);
    console.warn(`Exception occurred in isValidUrl - ${e}`);
  }

  if (domainName !== null && domainName !== "") {
    if (
      domainName.toLowerCase().endsWith(WebConstant.COM_DOMAIN) ||
      domainName.toLowerCase().endsWith(WebConstant.ORG_DOMAIN)
    ) {
      if (destinationPageUrl && /.*['<>();"].*/.test(destinationPageUrl)) {
        console.debug("The DURL contains special characters in the blacklist");
      } else {
        isValidDurl = true;
      }
    }
  }

  return isValidDurl;
}

// Utility to get cb_login cookie value
export function getCbLoginCookieValue(){
    const name = WebConstant.cbLoginCookieName + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookies = decodedCookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
        let c = cookies[i].trim();
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return null;
};